module.exports = __webpack_public_path__ + "static/img/local_logo.3a02adb7.png";